var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"VuePassword__Toggle"},[_c('md-icon',{staticClass:"plus-icon-material"},[_vm._v("person_add")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }